import { createStore } from 'vuex'


import OcultarPreguntas from './OcultarPreguntasFormulario.js'
import CondicionesFormulario from './CondicionesFormulario.js'
import AjaxFormulario from './AjaxFormulario.js'

export default createStore({
  state: { "Precios": {} },
  mutations: {
    actualizarRespuestaFormulario (state, Mutacion) {


      let Formulario = Mutacion.formulario;
      let Orden = Mutacion.question;
      let response = Mutacion.response;

      if (Mutacion.validate || Mutacion.validate == false)
      {
        //Guardamos si la validacion de la respuesta
        state[Formulario]["data"][Orden]["validate"] = Mutacion.validate;

      } else {

        //console.log("No se ha guardado la validacion");

      }

      if (Mutacion.price)
      {

        //Guardamos las preguntas que tienen subapartados
        state[Formulario]["data"][Orden]["price"] = Mutacion.price;

      } else {

        //console.log("No se ha guardado el resto de respuestas");

      }


      if (Mutacion.periodo)
      {

        //Guardamos las preguntas que tienen subapartados
        state[Formulario]["data"][Orden]["periodo"] = Mutacion.periodo;

      } else {

        //console.log("No se ha guardado el resto de respuestas");

      }

      if (Mutacion.products)
      {

        //Guardamos las preguntas que tienen subapartados
        state[Formulario]["data"][Orden]["products"] = Mutacion.products;

      } else {

        //console.log("No se ha guardado el resto de respuestas");

      }


      if (Mutacion.count)
      {

        //Guardamos las preguntas que tienen subapartados
        state[Formulario]["data"][Orden]["count"] = Mutacion.count;

      } else {

        //console.log("No se ha guardado el resto de respuestas");

      }



      if (Mutacion.allresponses)
      {
        //Guardamos las preguntas que tienen subapartados
        state[Formulario]["data"][Orden]["allresponses"] = Mutacion.allresponses;

      } else {

        //console.log("No se ha guardado el resto de respuestas");

      }

      //Guardamos la respuesta
      state[Formulario]["data"][Orden]["response"] = response;


      if (state[Formulario]["data"][Orden]["validate"] == true && state[Formulario]["data"][Orden]["response"] != null)
      {
        
        //Aqui Recalculo todas los Display de las Preguntas en base a las Condiciones
        state[Formulario]["data"] = CondicionesFormulario.RecalcularCondiciones(state[Formulario]["conditions"], state[Formulario]["data"]);

        let SiguientePregunta = OcultarPreguntas.proximaPregunta(state[Formulario]["data"], Orden);

        
        if (SiguientePregunta != false)
        {

          //Doy a Siguiente Automaticamente con la pregunta es de respuesta única
          if (state[Formulario]["data"][Orden]["tipo"] == "AlgoliaSearchOne" ||  state[Formulario]["data"][Orden]["tipo"] == "SelectOne")
          {

            if (state[Formulario]["name"])
            {
  
              dataLayer.push({'LastForm' : state[Formulario]["name"]});
              dataLayer.push({'LastQuestion' : SiguientePregunta});
              dataLayer.push({'event': 'SiguientePregunta'});

            }

            state[Formulario]["ActiveQuestion"] = SiguientePregunta;

          }

        }

      }
      

    },

    IrAtrasFormulario (state, Formulario) {


      let Actual = state[Formulario]["ActiveQuestion"];

      let SiguientePregunta = OcultarPreguntas.previaPregunta(state[Formulario]["data"], Actual);
  

      state[Formulario]["ActiveQuestion"] = SiguientePregunta;


      

    },

    async IrHaciaDelanteFormulario (state, Formulario) {

      let Actual = state[Formulario]["ActiveQuestion"];


    

      if (state[Formulario]["data"][Actual]["validate"] == true && state[Formulario]["data"][Actual]["response"] != null)
      {

        //Aqui Recalculo todas los Display de las Preguntas en base a las Condiciones
        state[Formulario]["data"] = CondicionesFormulario.RecalcularCondiciones(state[Formulario]["conditions"], state[Formulario]["data"]);

        let SiguientePregunta = OcultarPreguntas.proximaPregunta(state[Formulario]["data"], Actual);
        
        if (SiguientePregunta != false)
        {

          if (state[Formulario]["name"])
          {
  
            dataLayer.push({'LastForm' : state[Formulario]["name"]});
            dataLayer.push({'LastQuestion' : SiguientePregunta});
            dataLayer.push({'event': 'SiguientePregunta'});


          }

          state[Formulario]["ActiveQuestion"] = SiguientePregunta;

          //Quitar en produccion
          //let Resultados = await AjaxFormulario.CrearMatrizConResultados(state[Formulario]["data"]);          

        } else {

          state[Formulario]["loading"] = true; 

          var Resultados = await AjaxFormulario.CrearMatrizConResultados(state[Formulario]["data"]);

          let Solicitud = await AjaxFormulario.EnviarSolicitud(state[Formulario]["ajaxUrl"], Resultados);


          if (Solicitud.status == "OK")
          {

            let idSolicitud = Solicitud["idSolicitud"];

            state[Formulario]["idSolicitud"] = idSolicitud;

            if (Solicitud["solicitudes"])
            {
              
              //Apartado especial para multiples productos
              if (Resultados["PrecioProducto"]){

                if (Resultados["PrecioProducto"]["products"]){

                  let productos = Resultados["PrecioProducto"]["products"];

                  for (let prod in productos)
                  {

                    Resultados["PrecioProducto"]["products"][prod]["idSolicitud"] = Solicitud["solicitudes"][prod];

                  }
                } 

              }

              var RespuestasFormulario = Resultados;
              RespuestasFormulario["solicitudes"] = Solicitud["solicitudes"];
              console.log(RespuestasFormulario);

            } else {

              var RespuestasFormulario = Resultados;
              RespuestasFormulario["idSolicitud"] = idSolicitud;

            }


            if (state[Formulario]["urlIntegromat"] && state[Formulario]["urlIntegromat"] != null)
            {

              let RequestIntegromat = {"data" : RespuestasFormulario, "presupuesto": Solicitud["presupuesto"]};

              let RespuestaIntegromat = await AjaxFormulario.EnviarSolicitud(state[Formulario]["urlIntegromat"], RequestIntegromat);


              if (RespuestaIntegromat["status"] == "OK")
              {
  
                state[Formulario]["ValidateForm"] = true;
                
                if (state[Formulario]["name"])
                {
  
                  if (state[Formulario]["conversionValue"])
                  {
  
                    //dataLayer.push({'conversionValue': state[Formulario]["conversionValue"]});
                    dataLayer.push({'event': state[Formulario]["name"]+"Conversion"});
  
                  } else {
  
                    dataLayer.push({'event': state[Formulario]["name"]+"Conversion"});
  
                  }
  
  
                }
                
  
  
              } else {
  
                state[Formulario]["ValidateForm"] = false;
  
              }

            } else {

              state[Formulario]["ValidateForm"] = true;
                
              if (state[Formulario]["name"])
              {

                if (state[Formulario]["conversionValue"])
                {

                  //dataLayer.push({'conversionValue': state[Formulario]["conversionValue"]});
                  dataLayer.push({'event': state[Formulario]["name"]+"Conversion"});

                } else {

                  dataLayer.push({'event': state[Formulario]["name"]+"Conversion"});

                }


              }


            }


            if (state[Formulario]["urlLoad"] && state[Formulario]["urlLoad"] != null)
            {


              let codigoSolicitud = Solicitud["presupuesto"];

              let urlRedirection = state[Formulario]["urlLoad"]+"?idPresupuesto="+codigoSolicitud;
              

              let ModalidDePagoBusqueda = await CondicionesFormulario.buscarPreguntaporCodigo("ModalidadPago", state[Formulario]["data"]);
              let TipoSeguroBusqueda = await CondicionesFormulario.buscarPreguntaporCodigo("TipoDeSeguro", state[Formulario]["data"]);
              let agente = await AjaxFormulario.getCookie("id_agente_alg");


              var variablesUrlFinal = {};


              if (ModalidDePagoBusqueda.status == "OK")
              {

                variablesUrlFinal["PeriodoSeleccionado"] = ModalidDePagoBusqueda.data.response;

              }


              if (TipoSeguroBusqueda.status == "OK")
              {

                variablesUrlFinal["etiquetaPreMarcada"] = TipoSeguroBusqueda.data.response;

              }


              if (agente != "" & agente != null)
              {

                variablesUrlFinal["idAgente"] = agente;

              }


              
              // Añadir variables de variablesUrlFinal a urlRedirection si tiene valores
              if (Object.keys(variablesUrlFinal).length > 0) {
                const queryParams = new URLSearchParams();
                for (let key in variablesUrlFinal) {
                  if (variablesUrlFinal[key] != null && variablesUrlFinal[key] != "") {
                    queryParams.append(key, variablesUrlFinal[key]);
                  }
                }
                const queryString = queryParams.toString();
                if (queryString) {
                  urlRedirection += "&" + queryString;
                }
              }
              
              console.log(urlRedirection);

              window.location.href = urlRedirection;

            }


          } else {

            state[Formulario]["ValidateForm"] = false;

          }

          state[Formulario]["loading"] = false; 

        }

      }

    },

    actualizarOpcionesdeRespuesta (state, Mutacion) {

      let Formulario = Mutacion.formulario;
      let Orden = Mutacion.question;
      let Answers = Mutacion.answers;

      state[Formulario]["data"][Orden]["answers"] = Answers;


    },


    actualizarCampoPregunta (state, Mutacion) {

      let Formulario = Mutacion.formulario;
      let Orden = Mutacion.question;
      let Pregunta = Mutacion.pregunta;


      state[Formulario]["data"][Orden] = Pregunta;

    },

    seleccionarProductoParrilla (state, codigo) {

      state["ProductoSeleccionadoEnParrilla"] = codigo;

    },

    addAddonParrilla(state, codigo) {

      state["AddonsSeleccionados"].push(codigo);

    },

    resetAddonsParrilla(state, extensiones) {

      state["AddonsSeleccionados"] = extensiones;

    },

    resetPeriodoSeleccionado(state, periodo) {

      state["PeriodoSeleccionado"] = periodo;

    },

    ActualizarPreciosPresupuesto(state, Precios) {

      state["Precios"] = Precios;
      state["quotation"] = true;

    },

    ActualizarPrecioFinal(state, Precio) {

      state["PrecioFinal"] = Precio;

    },

    ActualizarNumeroAsegurados(state, NumeroAsegurados) {

      state["NumeroAsegurados"] = NumeroAsegurados;

    },

    ActualizarPricing(state, Pricing) {

      state["Pricing"]["products"] = Pricing;

    },

    ActualizarEmail(state, email) {

      state["email"] = email;

    },

    ActualizarTelefono(state, valor) {

      state["telefono"] = valor;

    },

    ActualizarRC(state, valor) {

      state["RC"] = valor;

    },

    ActualizarNombreTomador(state, valor) {

      state["NombreTomador"] = valor;

    },

    ActualizarFechaNacimientoTomador(state, valor) {

      state["FechaNacimientoTomador"] = valor;

    },

    ActualizarAsegurados(state, asegurados) {

      state["asegurados"] = asegurados;

    },

    ActualizarTipoTomador(state, tipo) {

      state["presupuestoTipo"] = tipo;

    },

    ActualizarIdPresupuesto(state, id) {

      state["idPresupuesto"] = id;

    },

    ActualizarNavbar(state, navbar) {

      state["Header"]["navbar"] = navbar;

    },

    CambiarCargando(state, navbar) {

      state["cargando"] = navbar;

    },

    CambiarAjax(state, url) {

      state["Formulario"]["ajaxUrl"] = url;

    },

    CambiarIntegromat(state, url) {

      state["Formulario"]["urlIntegromat"] = url;

    },


    CambiarDiasPromoDinamica(state, dias) {

      state["DiasPromoAmazon"] = dias;

    },

    ImportarDatosEstado(state, datos) {

      for (let numero of Object.keys(datos))
      {

          state[numero] = datos[numero];      

      }
    }


  },
  actions: {

    async getDataJson({commit}, url) {

      try {

        var axios = require('axios');

        let Datos = await axios(
            {
                method: 'get',
                url: url,
                config: { headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json' 
                  }}
            }
        );

        let datos = await Datos.data;

        commit('ImportarDatosEstado', datos)

        return Datos.data;
        
      } catch (error) {

          let retorno = {"status" : "KO", "message" : error};
          return retorno;
          
      }

    },


  },
  modules: {
  }
})
